import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { NotificationModel } from '../notification-model/notification.model'

const API_ROOT_URL = environment.ApiRoot + '/nhatkythaotackho';
const API_ROOT_SETAUTOHANMUC = environment.ApiRoot + '/hanmuc_phongban';
const API_ROOT_URL_TTTB = environment.ApiRoot + '/tttb';

@Injectable()
export class NotificationService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	totalNof$: BehaviorSubject<number> = new BehaviorSubject(0);
	isOpenNotifyDropdown$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(Idnv, IdChucdanh, cocauid): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/NhatKyThaoTacKho_List?Idnv=${Idnv}&IdChucdanh=${IdChucdanh}&cocauid=${cocauid}`, {
			headers: httpHeaders,

		});
	}
	getDataHistory(Idnv, IdChucdanh, cocauid): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/historyofnotify/HistoryofNotify_List?Idnv=${Idnv}&IdChucdanh=${IdChucdanh}&cocauid=${cocauid}`, {
			headers: httpHeaders,
		});
	}
	getDataHistoryNotifyandRemind(Idnv, IdChucdanh, cocauid): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/historyofnotify/HistoryofNotifyandRemind_List?Idnv=${Idnv}&IdChucdanh=${IdChucdanh}&cocauid=${cocauid}`, {
			headers: httpHeaders,
		});
	}
	getDataGroupNotify(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL_TTTB + `/TTTB_List`;
		return this.http.get<any>(url, {headers: httpHeaders});
	}
	getDataDetailGroupNotify(category: string, loaiTBID: number, idCheckers: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL_TTTB + `/TTTB_List_Detail?category=${category}&loaiTBID=${loaiTBID}&idCheckers=${idCheckers}`;
		return this.http.get<any>(url, {headers: httpHeaders});
	}
	updateStatusHistoryNotifyandRemind(item: NotificationModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/historyofnotify/HistoryofNotifyandRemind_UpdateStatus?Id=${item.Id}`, { headers: httpHeaders });
	}
	removeHistoryNotifyandRemind(item: NotificationModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/historyofnotify/HistoryofNotifyandRemind_Remove?Id=${item.Id}`, { headers: httpHeaders });
	}
	markAllRead(Idnv : number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(environment.ApiRoot + `/historyofnotify/HistoryofNotifyandRemind_MarkAllRead`, Idnv, { headers: httpHeaders });
	}
}
